<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      There are many types of plans and different plans are required depending on the size and
      complexity of the project.
    </p>
    <p class="mb-5">Some Types of Plans include:</p>
    <ul class="default-list">
      <li>Site Plans</li>
      <li>Floor Plans</li>
      <li>Elevations</li>
      <li>Electrical Plans</li>
      <li>Engineering Plans</li>
    </ul>
    <p class="mb-5">
      When plans and drawings of a proposed building or structure have been prepared, many copies
      are made for the people who will use them.
    </p>
    <h4 class="mb-5">Your Task:</h4>
    <p class="mb-5">Drag and drop the correct use of plans to where they belong.</p>

    <draggable class="list-group mb-5" :list="list1" group="people" :disabled="!isEditable">
      <div class="list-group-item" v-for="element in list1" :key="element.name">
        <span>{{ element.name }}</span>
      </div>
    </draggable>

    <div
      class="vx-row flex items-center justify-center"
      v-for="(question, index) in questions"
      :key="index"
      :class="{ wrong: !correct_answers['question' + index] }"
    >
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">{{ question.question }}</div>
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <draggable
          class="list-group draggable-area"
          :list="answers['question' + index]"
          group="people"
          @change="removeOldSelection(index)"
          :disabled="!isEditable"
        >
          <div
            class="list-group-item"
            v-for="element in answers['question' + index]"
            :key="element.name"
          >
            <span>{{ element.name }}</span>
          </div>
        </draggable>
        <match-select
          :pool="list1"
          :answer="answers['question' + index]"
          :label="question.question"
          :editable="isEditable"
        />
      </div>
    </div>
    <div class="overflow-hidden mb-5" v-if="isEditable">
      <button class="btn btn-secondary btn-size-medium mr-5" @click="checkAnswers">
        Check Answers
      </button>
      <button class="btn btn-secondary danger btn-size-medium" @click="resetAnswers">Reset</button>
    </div>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import draggable from 'vuedraggable';
import MatchSelect from '@/components/UI/MatchSelect';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  components: { draggable, MatchSelect },
  data() {
    return {
      questions: {
        1: { question: 'Owner/client' },
        2: { question: 'Structural, electrical and mechanical engineers' },
        3: { question: 'Council health and building surveyors' },
        4: { question: 'Council town planning officers' },
        5: { question: 'Financial institutions officers' },
        6: { question: 'Builder/estimator' },
        7: { question: 'Builder' },
        8: {
          question:
            'Subcontractors such as concreters, bricklayers, electricians, tilers and painters',
        },
        9: {
          question:
            'Suppliers of prefabricated building components such as roof trusses, windows, air conditioning and heating',
        },
      },
      answers: {
        question1: [],
        question2: [],
        question3: [],
        question4: [],
        question5: [],
        question6: [],
        question7: [],
        question8: [],
        question9: [],
      },
      correct_answers: {
        question1: true,
        question2: true,
        question3: true,
        question4: true,
        question5: true,
        question6: true,
        question7: true,
        question8: true,
        question9: true,
      },
      list1: [
        { name: 'to see that the design is as they imagined it', id: 1 },
        { name: 'to design their part of the structure', id: 2 },
        {
          name: 'to make sure that the building conforms to building codes and council regulations',
          id: 3,
        },
        { name: 'to make sure that the building conforms to council planning regulations', id: 4 },
        { name: 'to decide whether approval for finance for construction will be given', id: 5 },
        { name: 'to cost the building and to prepare a quote', id: 6 },
        { name: 'to construct the building', id: 7 },
        { name: 'to prepare their quotes to carry out their part of the construction', id: 8 },
        { name: 'to calculate their prices for their part of the job', id: 9 },
      ],
    };
  },
  methods: {
    save() {
      this.data = this.answers;
      this.saveActivity(this.$route.params.slug, this.data, -1);
    },
    removeOldSelection(index) {
      if (this.answers['question' + index].length > 1) {
        let lastElem =
          this.answers['question' + index][this.answers['question' + index].length - 1];
        for (let i = 0; i < this.answers['question' + index].length - 1; i++) {
          this.list1.push(this.answers['question' + index][i]);
        }
        this.answers['question' + index] = [];
        this.answers['question' + index].push(lastElem);
      }
    },
    checkAnswers() {
      for (let i = 1; i <= 9; i++) {
        if (this.answers['question' + i].length) {
          if (this.answers['question' + i][0].id != i) {
            this.correct_answers['question' + i] = false;
          } else {
            this.correct_answers['question' + i] = true;
          }
        }
      }
    },
    resetAnswers() {
      for (let index = 1; index <= 9; index++) {
        if (this.answers['question' + index].length > 0) {
          let lastElem = this.answers['question' + index][0];
          this.answers['question' + index] = [];
          this.correct_answers['question' + index] = true;
          this.list1.push(lastElem);
        }
      }
      this.list1 = this.list1.sort(() => 0.5 - Math.random());
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    if (this.data.question1) {
      this.answers = this.data;

      for (let i = 1; i <= 9; i++) {
        if (this.answers['question' + i].length > 0) {
          let id = this.answers['question' + i][0].id;
          this.list1 = this.list1.filter(function (item) {
            return item.id !== id;
          });
        }
      }
    }
    //Shuffle the answers array
    this.list1 = this.list1.sort(() => 0.5 - Math.random());
    this.checkAnswers();
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
  margin: 0;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
.list-group {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group.draggable-area {
  border: 1px dashed #ccc;
  min-height: 45px;
}
</style>
